import React from 'react';
// import {Link} from "react-router-dom";

import createLink from "../../../../libs/createLink";


import {Button, ButtonGroup} from "../../../components/Button";
import Dropdown from "../../../components/Dropdown";
import {config} from "../../../../config";
import Modal from "../../../components/Modal";
import AdvancedEditorTopic from "../../../components/advanced-editor/AdvancedEditorTopic";
import {Can} from "../../../../ability-context";
import CtaCannot from "../../../components/CtaCannot";
// import Title from "../../../components/Title";
import {canonical} from "../../../../libs/helper";
import Breadcrumbs from "../../../components/Breadcrumbs";
//import qs from "qs";

class ToplineCategory extends React.Component {
    constructor(props) {
        super(props);

        this.params = window.location.search || "";

        this.state = {
            toggleEditor: false,
        }
    }


    render() {
        let gender = Array.isArray(this.props.filter["owner.profile.gender"]) ? this.props.filter["owner.profile.gender"] : [this.props.filter["owner.profile.gender"]];

        let currentForumName = "";
        if(this.props.match && this.props.match.params && this.props.match.params.slug && this.props.forumChildrens && this.props.forumChildrens.childrens){
            let forum = this.props.forumChildrens.childrens.filter(item => item.slug === this.props.match.params.slug);
            currentForumName = forum && forum[0] && forum[0].name;
        }

        let breadCrumbsData = [];

        if(this.props.breadcrumbs){
            breadCrumbsData.push({name : "Forum Sexe", link : canonical(createLink("forum"), "", "forum"), to : createLink("forum")});
            this.props.breadcrumbs.forEach((item, index) =>{
                if(this.props.forumChildrens.isDating) {
                    breadCrumbsData.push({name : item.name, link : canonical(`${createLink("forum")}/${item.slug}`, "", "forumCategory"), to : `${createLink("forum")}/${item.slug}`});
                }
                else{
                    let url = createLink("forumCategory", {categoryParent : {slug : this.props.forumChildrens.slug === item.slug && index-1 >= 1 ? this.props.breadcrumbs[index-1].slug : ""},category : {_id : item._id, slug : item.slug}});
                    breadCrumbsData.push({name : item.name, link : canonical(url, this.props.breadcrumbs.length === (index + 1) ? this.params : "", "forumCategory"), to : url});
                }
            });
        }

        // console.log(breadCrumbsData, this.props.breadcrumbs);

        return (
            <div className={`topline subcategory`}>
                <div className={`title-wrapper subcategory`}>
                    <div className="title-category">
                        <div
                            className={`title ${this.props.forumChildrens.description.length > 0 ? '' : 'full-height'}`}>
                            {/*<span><Title className={"title-wrapper"} heading={"heading-1"} display={"display-0"}><Link to={createLink("forum")}>Forum Sexe</Link></Title></span>*/}

                            {/*/!*<span> {this.props.forumChildrens.name.length > 70 ? this.props.forumChildrens.name.substring(0, 70) + "..." : this.props.forumChildrens.name}MMM</span>*!/*/}

                            {/*{this.props.breadcrumbs.map((item, index) =>*/}
                            {/*    this.props.forumChildrens.isDating ? (*/}
                            {/*            <span key={item._id}>*/}
                            {/*                <Link to={`${createLink("forum")}/${item.slug}`}>{item.name}</Link>*/}
                            {/*            </span>*/}
                            {/*    ) : (*/}
                            {/*        <span key={item._id}>*/}
                            {/*            <Title className={"title-wrapper"} heading={"heading-2"} display={"display-0"}>*/}
                            {/*            {item.parentId === "" ? this.props.forumChildrens.slug === item.slug ? item.name : <Link to={`${createLink("forum")}/${item.slug}`}>{item.name}</Link> :*/}
                            {/*                this.props.forumChildrens.slug === item.slug && currentForumName === "" ?*/}
                            {/*                    item.name*/}
                            {/*                    :*/}
                            {/*                    <Link className={"title-link"} to={createLink("forumCategory", {categoryParent : {slug : this.props.forumChildrens.slug === item.slug && index-1 >= 1 ? this.props.breadcrumbs[index-1].slug : ""},category : {_id : item._id, slug : item.slug}})}>*/}
                            {/*                        {item.name}*/}
                            {/*                    </Link>*/}
                            {/*            }*/}
                            {/*            </Title>*/}
                            {/*        </span>*/}
                            {/*    )*/}
                            {/*)}*/}
                            <Breadcrumbs data={breadCrumbsData} />
                            {currentForumName !== undefined && currentForumName !== "" && (<span>{currentForumName}</span>)}
                            {/*{this.props.breadcrumb && this.props.breadcrumb.map((breadcrumb, index) => (*/}
                            {/*breadcrumb.link ?*/}
                            {/*<span ><Link to={breadcrumb.link}>{this.props.forumChildrens.name}</Link></span>*/}
                            {/*<span key={index}> {this.props.forumChildrens.name.length > 70 ? this.props.forumChildrens.name.substring(0, 70) + "..." : this.props.forumChildrens.name}</span>*/}
                            {/*))}*/}
                        </div>
                        {this.props.forumChildrens.description.length > 0 && (
                            <p className="text small medium-grey mt-4">{this.props.forumChildrens.description}</p>
                        )}
                    </div>
                    {/*<div className="follow-forum"><Follows _id={this.props._id} type="forums"/></div>*/}
                </div>
                {this.props.forumChildrens.childrens && this.props.forumChildrens.childrens.length === 0 && (
                    <div className={`wrapper-settings`}>
                        <div className="wrapper-btn">
                            <Dropdown activableComponent={(
                                <Button size={"small"}
                                        icon={"sliders"}
                                        className={"forum-btn-settings"}
                                />
                            )}>
                                <ul className="dropdown-menu forum-filter">
                                    <li className={`menu-item ${this.props.filter.sort === 0 ? 'active' : ''}`}
                                        onClick={() => {
                                            this.props.handleFilterSort(0)
                                        }}>Mis à jour récemment
                                    </li>
                                    <li className={`menu-item ${this.props.filter.sort === 1 ? 'active' : ''}`}
                                        onClick={() => {
                                            this.props.handleFilterSort(1)
                                        }}>Date de début
                                    </li>
                                    <li className={`menu-item ${this.props.filter.sort === 2 ? 'active' : ''}`}
                                        onClick={() => {
                                            this.props.handleFilterSort(2)
                                        }}>Avec le plus de réponses
                                    </li>
                                    <li className={`menu-item ${this.props.filter.sort === 3 ? 'active' : ''}`}
                                        onClick={() => {
                                            this.props.handleFilterSort(3)
                                        }}>Le plus vu
                                    </li>
                                </ul>
                            </Dropdown>

                            {this.props.forumChildrens.isDating && (
                                <ButtonGroup>
                                    {config.genderList.map((item, genderIndex) => {
                                        if (genderIndex > 0) {
                                            return <Button key={genderIndex}
                                                           active={gender.includes(genderIndex) ? 'active' : ''}
                                                           onClick={() => this.props.handleGender(genderIndex)}
                                                           content={item}/>
                                        } else return null;
                                    })}
                                </ButtonGroup>
                            )}

                            <Can action="create" subject="Topic" passThrough>
                                {can => {
                                    return can ? (
                                        <Button className="start-topic"
                                                btnStyle={"primary-reverse"}
                                                size={"small"}
                                                onClick={() => this.setState({toggleEditor: true})}
                                                icon={"plus"}
                                                content="Commencer un sujet"/>
                                    ) : (
                                        <CtaCannot action={"createTopic"} isModal={true} button={{content : "Commencer un sujet"}} />
                                    )}}
                            </Can>
                                <Modal toggle={this.state.toggleEditor}
                                       handleClose={() => this.setState({toggleEditor: false})}>
                                    <AdvancedEditorTopic
                                        handleClose={() => this.setState({toggleEditor: false})}
                                        forumId={this.props.forumId || this.props.forumChildrens._id}
                                    />
                                </Modal>

                            {/*{this.props.currentUser && this.props.currentUser._id && (*/}
                            {/*<Button size={"small"}*/}
                            {/*content="Marquer ce forum comme lu"/>*/}
                            {/*)}*/}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default ToplineCategory;